export const LogikFormItemWarnings = ({
    warnings,
    warningsLogikName,
}: {
    warnings: React.ReactNode[];
    warningsLogikName?: string[];
}): JSX.Element => {
    return (
        <>
            {warnings?.map((w, i) => (
                <div className='antd-custom-form-item-info' key={i}>
                    {w}
                </div>
            ))}
            {warnings.length == 0 &&
                warningsLogikName?.map((w, i) => (
                    <div className='antd-custom-form-item-info' key={i}>
                        {w}
                    </div>
                ))}
        </>
    );
};
